// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdminGroupAttendance Styles */
.AdminGroupAttendance__content {
  flex: 1 1;
  padding: 20px;
  margin-left: 250px;
}

.AdminGroupAttendance__card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

.AdminGroupAttendance__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}

.AdminGroupAttendance__title {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
}

.AdminGroupAttendance__back-btn {
  background: #6c3be4;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
}

.AdminGroupAttendance__month-section {
  margin-bottom: 20px;
}

.AdminGroupAttendance__month-label {
  margin-right: 12px;
  font-weight: 500;
}

.AdminGroupAttendance__month-input {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
  font-size: 16px;
}

.AdminGroupAttendance__empty {
  text-align: center;
  padding: 40px;
  color: #666;
}

.AdminGroupAttendance__empty-title {
  font-size: 18px;
  margin-bottom: 8px;
}

.AdminGroupAttendance__empty-text {
  font-size: 14px;
}

.AdminGroupAttendance__table-container {
  overflow-x: auto;
}

.AdminGroupAttendance__table {
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border: 1px solid #ddd;
  min-width: 600px;
}

.AdminGroupAttendance__table thead tr {
  background: #f8f9fa;
}

.AdminGroupAttendance__th-students {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: left;
  min-width: 200px;
  position: sticky;
  left: 0;
  background: #f8f9fa;
  z-index: 10;
}

.AdminGroupAttendance__th-slot {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: center;
  min-width: 180px;
  vertical-align: top;
}

.AdminGroupAttendance__slot-date {
  font-size: 12px;
  font-weight: 600;
  color: #6c3be4;
  margin-bottom: 4px;
}

.AdminGroupAttendance__slot-time {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
}

.AdminGroupAttendance__slot-subject {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.AdminGroupAttendance__slot-buttons {
  margin-top: 8px;
}

.AdminGroupAttendance__bulk-btn {
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 12px;
  cursor: pointer;
  margin-right: 4px;
  color: #fff;
}

.AdminGroupAttendance__bulk-btn--present {
  background: #27ae60;
}

.AdminGroupAttendance__bulk-btn--absent {
  background: #e74c3c;
}

.AdminGroupAttendance__td-student {
  padding: 12px;
  border: 1px solid #ddd;
  font-weight: 500;
  position: sticky;
  left: 0;
  background: #fff;
  z-index: 5;
}

.AdminGroupAttendance__td-attendance {
  padding: 12px;
  border: 1px solid #ddd;
  text-align: center;
  position: relative;
  z-index: 1;
}

.AdminGroupAttendance__loading {
  font-size: 12px;
  color: #666;
}

.AdminGroupAttendance__status-btn {
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  position: relative;
  z-index: 1;
  transition: all 0.2s ease;
}

.AdminGroupAttendance__status-btn:hover {
  transform: scale(1.1);
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.AdminGroupAttendance__status-btn:active {
  transform: scale(0.95);
}

.AdminGroupAttendance__status-btn--present {
  background: #27ae60;
}

.AdminGroupAttendance__status-btn--absent {
  background: #e74c3c;
}

.AdminGroupAttendance__status-btn--unknown {
  background: #95a5a6;
}

.AdminGroupAttendance__legend {
  margin-top: 20px;
  font-size: 14px;
  color: #666;
}

.AdminGroupAttendance__legend-item {
  margin-bottom: 8px;
}

.AdminGroupAttendance__legend-present {
  color: #27ae60;
  font-weight: 600;
}

.AdminGroupAttendance__legend-absent {
  color: #e74c3c;
  font-weight: 600;
}

.AdminGroupAttendance__legend-unknown {
  color: #95a5a6;
  font-weight: 600;
}

/* Mobile Styles */
@media (max-width: 768px) {
  .AdminGroupAttendance__content {
    margin-left: 0;
    padding: 10px;
  }

  .AdminGroupAttendance__card {
    padding: 16px;
    border-radius: 8px;
  }

  .AdminGroupAttendance__header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 16px;
  }

  .AdminGroupAttendance__title {
    font-size: 20px;
  }

  .AdminGroupAttendance__back-btn {
    align-self: flex-end;
    padding: 6px 12px;
    font-size: 14px;
  }

  .AdminGroupAttendance__month-section {
    margin-bottom: 16px;
  }

  .AdminGroupAttendance__month-label {
    display: block;
    margin-bottom: 8px;
    margin-right: 0;
  }

  .AdminGroupAttendance__month-input {
    width: 100%;
    font-size: 14px;
  }

  .AdminGroupAttendance__empty {
    padding: 20px;
  }

  .AdminGroupAttendance__empty-title {
    font-size: 16px;
  }

  .AdminGroupAttendance__empty-text {
    font-size: 14px;
  }

  .AdminGroupAttendance__table-container {
    margin: 0 -16px;
    padding: 0 16px;
  }

  .AdminGroupAttendance__table {
    font-size: 12px;
  }

  .AdminGroupAttendance__th-students {
    padding: 8px;
    min-width: 120px;
    position: sticky;
    left: 0;
    background: #f8f9fa;
    z-index: 10;
  }

  .AdminGroupAttendance__th-slot {
    padding: 8px;
    min-width: 140px;
  }

  .AdminGroupAttendance__slot-date {
    font-size: 10px;
    margin-bottom: 2px;
  }

  .AdminGroupAttendance__slot-time {
    font-size: 12px;
    margin-bottom: 2px;
  }

  .AdminGroupAttendance__slot-subject {
    font-size: 10px;
    margin-bottom: 4px;
  }

  .AdminGroupAttendance__slot-buttons {
    margin-top: 4px;
  }

  .AdminGroupAttendance__bulk-btn {
    padding: 2px 6px;
    font-size: 10px;
    margin-right: 2px;
  }

  .AdminGroupAttendance__td-student {
    padding: 8px;
    font-size: 12px;
    position: sticky;
    left: 0;
    background: #fff;
    z-index: 5;
  }

  .AdminGroupAttendance__td-attendance {
    padding: 8px;
    position: relative;
    z-index: 1;
  }

  .AdminGroupAttendance__loading {
    font-size: 10px;
  }

  .AdminGroupAttendance__status-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
    position: relative;
    z-index: 1;
  }

  .AdminGroupAttendance__legend {
    margin-top: 16px;
    font-size: 12px;
  }

  .AdminGroupAttendance__legend-item {
    margin-bottom: 6px;
  }
}

/* Small Mobile Styles */
@media (max-width: 480px) {
  .AdminGroupAttendance__title {
    font-size: 18px;
  }

  .AdminGroupAttendance__th-students {
    min-width: 100px;
    position: sticky;
    left: 0;
    background: #f8f9fa;
    z-index: 10;
  }

  .AdminGroupAttendance__th-slot {
    min-width: 120px;
  }

  .AdminGroupAttendance__slot-date {
    font-size: 9px;
  }

  .AdminGroupAttendance__slot-time {
    font-size: 11px;
  }

  .AdminGroupAttendance__slot-subject {
    font-size: 9px;
  }

  .AdminGroupAttendance__bulk-btn {
    padding: 1px 4px;
    font-size: 9px;
  }

  .AdminGroupAttendance__td-student {
    font-size: 11px;
    position: sticky;
    left: 0;
    background: #fff;
    z-index: 5;
  }

  .AdminGroupAttendance__status-btn {
    width: 24px;
    height: 24px;
    font-size: 12px;
    position: relative;
    z-index: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Admin/AdminGroupAttendance.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;EACP,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,OAAO;IACP,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,OAAO;IACP,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,OAAO;IACP,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,UAAU;EACZ;AACF","sourcesContent":["/* AdminGroupAttendance Styles */\r\n.AdminGroupAttendance__content {\r\n  flex: 1;\r\n  padding: 20px;\r\n  margin-left: 250px;\r\n}\r\n\r\n.AdminGroupAttendance__card {\r\n  background: #fff;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.AdminGroupAttendance__header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.AdminGroupAttendance__title {\r\n  margin: 0;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n}\r\n\r\n.AdminGroupAttendance__back-btn {\r\n  background: #6c3be4;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 8px 16px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n.AdminGroupAttendance__month-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.AdminGroupAttendance__month-label {\r\n  margin-right: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.AdminGroupAttendance__month-input {\r\n  padding: 8px 12px;\r\n  border-radius: 6px;\r\n  border: 1px solid #ddd;\r\n  font-size: 16px;\r\n}\r\n\r\n.AdminGroupAttendance__empty {\r\n  text-align: center;\r\n  padding: 40px;\r\n  color: #666;\r\n}\r\n\r\n.AdminGroupAttendance__empty-title {\r\n  font-size: 18px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.AdminGroupAttendance__empty-text {\r\n  font-size: 14px;\r\n}\r\n\r\n.AdminGroupAttendance__table-container {\r\n  overflow-x: auto;\r\n}\r\n\r\n.AdminGroupAttendance__table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  background: #fff;\r\n  border: 1px solid #ddd;\r\n  min-width: 600px;\r\n}\r\n\r\n.AdminGroupAttendance__table thead tr {\r\n  background: #f8f9fa;\r\n}\r\n\r\n.AdminGroupAttendance__th-students {\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  text-align: left;\r\n  min-width: 200px;\r\n  position: sticky;\r\n  left: 0;\r\n  background: #f8f9fa;\r\n  z-index: 10;\r\n}\r\n\r\n.AdminGroupAttendance__th-slot {\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  text-align: center;\r\n  min-width: 180px;\r\n  vertical-align: top;\r\n}\r\n\r\n.AdminGroupAttendance__slot-date {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #6c3be4;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.AdminGroupAttendance__slot-time {\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.AdminGroupAttendance__slot-subject {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.AdminGroupAttendance__slot-buttons {\r\n  margin-top: 8px;\r\n}\r\n\r\n.AdminGroupAttendance__bulk-btn {\r\n  border: none;\r\n  border-radius: 4px;\r\n  padding: 4px 8px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  margin-right: 4px;\r\n  color: #fff;\r\n}\r\n\r\n.AdminGroupAttendance__bulk-btn--present {\r\n  background: #27ae60;\r\n}\r\n\r\n.AdminGroupAttendance__bulk-btn--absent {\r\n  background: #e74c3c;\r\n}\r\n\r\n.AdminGroupAttendance__td-student {\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  font-weight: 500;\r\n  position: sticky;\r\n  left: 0;\r\n  background: #fff;\r\n  z-index: 5;\r\n}\r\n\r\n.AdminGroupAttendance__td-attendance {\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  text-align: center;\r\n  position: relative;\r\n  z-index: 1;\r\n}\r\n\r\n.AdminGroupAttendance__loading {\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.AdminGroupAttendance__status-btn {\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 32px;\r\n  height: 32px;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  color: #fff;\r\n  position: relative;\r\n  z-index: 1;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.AdminGroupAttendance__status-btn:hover {\r\n  transform: scale(1.1);\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.2);\r\n}\r\n\r\n.AdminGroupAttendance__status-btn:active {\r\n  transform: scale(0.95);\r\n}\r\n\r\n.AdminGroupAttendance__status-btn--present {\r\n  background: #27ae60;\r\n}\r\n\r\n.AdminGroupAttendance__status-btn--absent {\r\n  background: #e74c3c;\r\n}\r\n\r\n.AdminGroupAttendance__status-btn--unknown {\r\n  background: #95a5a6;\r\n}\r\n\r\n.AdminGroupAttendance__legend {\r\n  margin-top: 20px;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n.AdminGroupAttendance__legend-item {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.AdminGroupAttendance__legend-present {\r\n  color: #27ae60;\r\n  font-weight: 600;\r\n}\r\n\r\n.AdminGroupAttendance__legend-absent {\r\n  color: #e74c3c;\r\n  font-weight: 600;\r\n}\r\n\r\n.AdminGroupAttendance__legend-unknown {\r\n  color: #95a5a6;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Mobile Styles */\r\n@media (max-width: 768px) {\r\n  .AdminGroupAttendance__content {\r\n    margin-left: 0;\r\n    padding: 10px;\r\n  }\r\n\r\n  .AdminGroupAttendance__card {\r\n    padding: 16px;\r\n    border-radius: 8px;\r\n  }\r\n\r\n  .AdminGroupAttendance__header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .AdminGroupAttendance__title {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .AdminGroupAttendance__back-btn {\r\n    align-self: flex-end;\r\n    padding: 6px 12px;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .AdminGroupAttendance__month-section {\r\n    margin-bottom: 16px;\r\n  }\r\n\r\n  .AdminGroupAttendance__month-label {\r\n    display: block;\r\n    margin-bottom: 8px;\r\n    margin-right: 0;\r\n  }\r\n\r\n  .AdminGroupAttendance__month-input {\r\n    width: 100%;\r\n    font-size: 14px;\r\n  }\r\n\r\n  .AdminGroupAttendance__empty {\r\n    padding: 20px;\r\n  }\r\n\r\n  .AdminGroupAttendance__empty-title {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .AdminGroupAttendance__empty-text {\r\n    font-size: 14px;\r\n  }\r\n\r\n  .AdminGroupAttendance__table-container {\r\n    margin: 0 -16px;\r\n    padding: 0 16px;\r\n  }\r\n\r\n  .AdminGroupAttendance__table {\r\n    font-size: 12px;\r\n  }\r\n\r\n  .AdminGroupAttendance__th-students {\r\n    padding: 8px;\r\n    min-width: 120px;\r\n    position: sticky;\r\n    left: 0;\r\n    background: #f8f9fa;\r\n    z-index: 10;\r\n  }\r\n\r\n  .AdminGroupAttendance__th-slot {\r\n    padding: 8px;\r\n    min-width: 140px;\r\n  }\r\n\r\n  .AdminGroupAttendance__slot-date {\r\n    font-size: 10px;\r\n    margin-bottom: 2px;\r\n  }\r\n\r\n  .AdminGroupAttendance__slot-time {\r\n    font-size: 12px;\r\n    margin-bottom: 2px;\r\n  }\r\n\r\n  .AdminGroupAttendance__slot-subject {\r\n    font-size: 10px;\r\n    margin-bottom: 4px;\r\n  }\r\n\r\n  .AdminGroupAttendance__slot-buttons {\r\n    margin-top: 4px;\r\n  }\r\n\r\n  .AdminGroupAttendance__bulk-btn {\r\n    padding: 2px 6px;\r\n    font-size: 10px;\r\n    margin-right: 2px;\r\n  }\r\n\r\n  .AdminGroupAttendance__td-student {\r\n    padding: 8px;\r\n    font-size: 12px;\r\n    position: sticky;\r\n    left: 0;\r\n    background: #fff;\r\n    z-index: 5;\r\n  }\r\n\r\n  .AdminGroupAttendance__td-attendance {\r\n    padding: 8px;\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n\r\n  .AdminGroupAttendance__loading {\r\n    font-size: 10px;\r\n  }\r\n\r\n  .AdminGroupAttendance__status-btn {\r\n    width: 28px;\r\n    height: 28px;\r\n    font-size: 14px;\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n\r\n  .AdminGroupAttendance__legend {\r\n    margin-top: 16px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .AdminGroupAttendance__legend-item {\r\n    margin-bottom: 6px;\r\n  }\r\n}\r\n\r\n/* Small Mobile Styles */\r\n@media (max-width: 480px) {\r\n  .AdminGroupAttendance__title {\r\n    font-size: 18px;\r\n  }\r\n\r\n  .AdminGroupAttendance__th-students {\r\n    min-width: 100px;\r\n    position: sticky;\r\n    left: 0;\r\n    background: #f8f9fa;\r\n    z-index: 10;\r\n  }\r\n\r\n  .AdminGroupAttendance__th-slot {\r\n    min-width: 120px;\r\n  }\r\n\r\n  .AdminGroupAttendance__slot-date {\r\n    font-size: 9px;\r\n  }\r\n\r\n  .AdminGroupAttendance__slot-time {\r\n    font-size: 11px;\r\n  }\r\n\r\n  .AdminGroupAttendance__slot-subject {\r\n    font-size: 9px;\r\n  }\r\n\r\n  .AdminGroupAttendance__bulk-btn {\r\n    padding: 1px 4px;\r\n    font-size: 9px;\r\n  }\r\n\r\n  .AdminGroupAttendance__td-student {\r\n    font-size: 11px;\r\n    position: sticky;\r\n    left: 0;\r\n    background: #fff;\r\n    z-index: 5;\r\n  }\r\n\r\n  .AdminGroupAttendance__status-btn {\r\n    width: 24px;\r\n    height: 24px;\r\n    font-size: 12px;\r\n    position: relative;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
